import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Action, EventAction, ConfigShowItems } from './shared/util';

@Component({
  selector: 'iw-btn-trigger',
  templateUrl: './btn-trigger.component.html',
  styleUrls: ['./btn-trigger.component.scss']
})
export class BtnTriggerComponent implements OnInit, OnDestroy {
  @Input() btnClass: Array<string>;
  @Input() disabled = false;
  @Input() iconClass: string;
  @Input() action: Action;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  @Output() itemClicked: EventEmitter<EventAction> = new EventEmitter<EventAction>();
  baseTitle = '';
  private _show: ConfigShowItems = {
    category: true,
    process: true,
    tramite: true,
    secondaryProcess: true
  };

  @Input()
  set show(v: Partial<ConfigShowItems>) {
    for (const key in v) {
      if (v.hasOwnProperty(key)) {
        this._show[key] = v[key];
      }
    }
    this.disabled = !Object.values(this.show).includes(true) ? true : false;
  }
  get show() {
    return this._show;
  }

  constructor() {}

  ngOnInit() {
    switch (this.action) {
      case 'create':
        this.baseTitle = 'Crear';
        break;
      case 'edit':
        this.baseTitle = 'Editar';
        break;
      case 'delete':
        this.baseTitle = 'Eliminar';
        break;
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  clickItem(item: number) {
    item = Number(item);
    switch (item) {
      case 1:
        this.itemClicked.emit({
          action: this.action,
          categoryAction: 'category'
        });
        break;
      case 2:
        this.itemClicked.emit({
          action: this.action,
          categoryAction: 'process'
        });
        break;
      case 3:
        this.itemClicked.emit({
          action: this.action,
          categoryAction: 'tramite'
        });
        break;
      case 4:
        this.itemClicked.emit({
          action: this.action,
          categoryAction: 'secondaryProcess'
        });
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/btn-trigger/btn-trigger.component.ts